import editor from './editor';
import { convertRemToPixels } from 'util/remUtil';

export const setFontSize = (): void => {
  editor.updateOptions({ fontSize: convertRemToPixels(0.85), suggestLineHeight: convertRemToPixels(1.7) });
};
